import React from "react";
import { useState } from "react";
import { Row, Col, Card, Table, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import Loader from "../../common/Loader";
import NoData from "../../common/NoData";
import Pagination from "../../common/Pagination/Pagination";
import { Translate } from "../../Enums/Tranlate";
import CardItem from "./CardItem";
import UsersService from "../../../services/UserService";
import AddUserModal from "./AddUserModal";
import { usePermissions } from "../../common/permissions";

const Users = () => {
	const [data, setData] = useState([
		{ id: 1, client_name: "Mohamed", phone: "(+996) 4444 4444" },
		{ id: 2, client_name: "Mohamed", phone: "(+996) 4444 4444" },
		{ id: 3, client_name: "Mohamed", phone: "(+996) 4444 4444" },
		{ id: 4, client_name: "Mohamed", phone: "(+996) 4444 4444" },
	]);
	const [hasData, setHasData] = useState(1);
	const [addModal, setAddModal] = useState(false);
	const [item, setItem] = useState({});
	const [loading, setLoading] = useState(false);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);
	const usersService = new UsersService();
	const Auth = useSelector((state) => state.auth?.auth);
	const { canAdd } = usePermissions();
	const search = useSelector((state) => state.auth.search);

	// useEffect(() => {
	// 	setLoading(true);
	// 	categoriesService
	// 		.getList()
	// 		.then((res) => {
	// 			if (res?.status) {
	// 				setData(res?.data?.data);
	// 				if (!!res?.data?.data?.length) {
	// 					setHasData(1);
	// 				} else {
	// 					setHasData(0);
	// 				}
	// 			}
	// 			setLoading(false);
	// 		})
	// 		.catch((e) => setLoading(false));
	// }, [shouldUpdate]);

	return (
		<div className="department">
			<div className="mb-4">
				<div className="search-card d-flex justify-content-between align-items-center">
					<div>
						<span
							style={{
								fontWeight: "600",
								textTransform: "capitalize",
								color: "#000",
							}}>
							{Translate[lang].users}
						</span>
					</div>
					<div className="add-admin">
						{canAdd("user") && (
							<Button
								variant="primary"
								className="me-2 h-75"
								onClick={() => {
									setItem({});
									setAddModal(true);
								}}>
								<i
									className={`la la-plus ${lang === "en" ? "mr-2" : "ml-2"}`}></i>
								{Translate[lang]?.add} {Translate[lang]?.user}
							</Button>
						)}
					</div>
				</div>
			</div>

			<Row>
				<Col lg={12}>
					<Card>
						<div
							className={`${hasData === 0 ? "text-center" : "table-style"} `}>
							{loading && (
								<div style={{ height: "400px" }}>
									<Loader />
								</div>
							)}

							{hasData === 1 && !loading && (
								<Table responsive>
									<thead>
										<tr className="text-center">
											<th>
												<strong>{Translate[lang]?.client_name}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.phone}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.action}</strong>
											</th>
										</tr>
									</thead>

									<tbody className="table-body">
										{data?.map((item, index) => {
											return (
												<CardItem
													index={index}
													setShouldUpdate={setShouldUpdate}
													key={index}
													item={item}
													setAddModal={setAddModal}
													setItem={setItem}
												/>
											);
										})}
									</tbody>
								</Table>
							)}
							{hasData === 0 && <NoData />}
							<Pagination
								setData={setData}
								service={usersService}
								shouldUpdate={shouldUpdate}
								setHasData={setHasData}
								setLoading={setLoading}
								search={search}
							/>
						</div>
					</Card>
				</Col>
			</Row>
			{addModal && (
				<AddUserModal
					addModal={addModal}
					setShouldUpdate={setShouldUpdate}
					setAddModal={() => setAddModal(false)}
					item={item}
				/>
			)}
		</div>
	);
};

export default Users;
